import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';

interface GeoStatusAlertProps {
  loading: boolean;
  error?: string | null;
  coords?: [number, number] | null;
  action?: string;
}

const GeoStatusAlert: FC<GeoStatusAlertProps> = ({
  loading,
  error,
  coords,
  action = 'logging',
}) => {
  if (loading) {
    return (
      <Box mt={2}>
        <Alert severity="info" icon={false}>
          <Box display="flex" alignItems="center">
            <CircularProgress size={16} style={{ marginRight: 8 }} />
            Acquiring GPS location...
          </Box>
        </Alert>
      </Box>
    );
  }

  if (error || !coords) {
    return (
      <Box mt={2}>
        <Alert severity="warning">
          We couldn&apos;t detect your location. Please enable location
          services on your device before {action}.
        </Alert>
      </Box>
    );
  }

  return null;
};

export default GeoStatusAlert;
